import meetingHistoryDispatcher from '../action/meetingHistory';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const meetingHistoryReducer = meetingHistoryDispatcher(initialState, {
  [meetingHistoryDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  })
});

export default meetingHistoryReducer;
